import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { entidad } from '../../../app/entities/entidad';

@Injectable({
	providedIn: 'root'
})
export class TraspasoSaldoService {


	constructor(private http: HttpClient) { }

	listaEntidades(): Observable<entidad[]> {
		return this.http.get<entidad[]>(environment.API_SECURITY + '/traspasoSaldo/catNiveles');
	}

	traspasoSaldo(saveForm: any): Observable<any> {
		return this.http.post(environment.API_SECURITY + '/traspasoSaldo', saveForm, {
			responseType: 'text', // sigues recibiendo texto
			observe: 'response'   // ahora también puedes leer status code
		});
	}

	traspasoSaldoHistorico(fechaInicio: string, fechaFin: string): Observable<any[]> {
		const url = `${environment.API_SECURITY}/traspasoSaldo/${fechaInicio}/${fechaFin}`;
		return this.http.get<any[]>(url);
	}

	reportHistorico(): Observable<any> {
		return this.http.get<any>(environment.API_SECURITY + '/traspasoSaldo');
	}

	obtenerSaldo(): Observable<any> {
		return this.http.get<any>(environment.API_SECURITY + '/saldos');
	}

}
